(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["viaim-deals-halloween"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('viaim-deals-halloween')) {
customElements.define('viaim-deals-halloween', class extends HTMLElement {
  connectedCallback() {
    clearInterval(this.timer);
    if (!this.bound) {
    this.bound = true;
    this.addEventListener('click', (event) => {
      const card = event.target.closest('.vdh-flip');
      if (card && this.contains(card)) this.flip(card, card.getAttribute('aria-pressed') !== 'true');
      if (event.target.closest('.vdh-link')) this.querySelectorAll('.vdh-flip').forEach((item) => this.flip(item, true));
    });
    }
    this.querySelectorAll('.vdh-back').forEach((face) => face.setAttribute('aria-hidden', 'true'));
    if (this.querySelector('[data-count]')) {
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
  }
  disconnectedCallback() { clearInterval(this.timer);  }
  flip(card, open) {
    card.setAttribute('aria-pressed', String(open));
    card.querySelector('.vdh-front').setAttribute('aria-hidden', String(open));
    card.querySelector('.vdh-back').setAttribute('aria-hidden', String(!open));
  }
  tick() {
    const start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end), now = Date.now();
    const label = this.querySelector('[data-count-label]'), count = this.querySelector('.vdh-count');
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) { count.hidden = true; label.hidden = true; return; }
    label.textContent = now < start ? label.dataset.startLabel : now < end ? label.dataset.endLabel : label.dataset.endedLabel;
    const remaining = Math.max(0, (now < start ? start : end) - now);
    const values = [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, Math.floor(remaining / 1000) % 60];
    this.querySelectorAll('[data-count]').forEach((node, index) => { node.textContent = String(values[index]).padStart(2, '0'); });
    if (now >= end) clearInterval(this.timer);
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-image-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('viaim-image-carousel'))customElements.define('viaim-image-carousel',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
  this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-index]')];
  this.pauseButton=this.querySelector('[data-pause]');this.index=0;this.hovered=false;this.focused=false;this.visible=false;
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.stopped=this.reduced.matches||this.dataset.autoplay!=='true';this.editor=false;
  this.interval=Math.max(4000,Number(this.dataset.interval)||6000);this.setAttribute('data-ready','');
  const listen=(target,event,callback)=>target?.addEventListener(event,callback,{signal});
  this.dots.forEach((dot,i)=>listen(dot,'click',e=>this.go(i,true,e.detail===0)));
  listen(this.querySelector('[data-prev]'),'click',e=>this.go(this.index-1,true,e.detail===0));
  listen(this.querySelector('[data-next]'),'click',e=>this.go(this.index+1,true,e.detail===0));
  listen(this.pauseButton,'click',()=>{this.stopped=!this.stopped;this.schedule()});
  listen(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.schedule()}});
  listen(this,'pointerleave',()=>{this.hovered=false;this.schedule()});
  listen(this,'focusin',()=>{this.focused=true;this.schedule()});
  listen(this,'focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule()}});
  listen(document,'visibilitychange',()=>this.schedule());
  listen(this.reduced,'change',()=>{if(this.reduced.matches)this.stopped=true;this.schedule()});
  listen(this,'keydown',e=>{
   if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)||e.target.closest('a'))return;
   e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?this.slides.length-1:this.index+(e.key==='ArrowRight'?1:-1);
   this.go(next,true,true);this.dots[this.index]?.focus();
  });
  listen(this,'pointerdown',e=>{if(!e.isPrimary||e.target.closest('a,button'))return;this.start={x:e.clientX,y:e.clientY,id:e.pointerId}});
  listen(this,'pointerup',e=>{
   if(!this.start||e.pointerId!==this.start.id)return;
   const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;
   if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.index+(dx<0?1:-1),true,false);
  });
  listen(this,'pointercancel',()=>{this.start=null});
  listen(this,'shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.slide===e.detail.blockId);if(i<0)return;this.editor=true;this.go(i,false,true)});
  listen(this,'shopify:block:deselect',()=>{this.editor=false;this.schedule()});
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:.15});this.observer.observe(this);
  this.go(0,false,true);
 }
 go(index,manual=false,instant=false){
  if(!this.slides.length)return;
  this.toggleAttribute('data-instant',instant);if(manual)this.stopped=true;
  this.index=(index+this.slides.length)%this.slides.length;
  this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));const video=slide.querySelector('video');if(video&&!active){video.pause();if(video.readyState>0)video.currentTime=0}});
  this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
  this.schedule();
 }
 schedule(){
  clearTimeout(this.timer);
  const playing=!this.stopped;
  if(this.pauseButton){this.pauseButton.setAttribute('aria-label',playing?this.pauseButton.dataset.pauseLabel:this.pauseButton.dataset.playLabel);this.pauseButton.dataset.state=playing?'playing':'paused'}
  this.querySelector('.vic__slides').setAttribute('aria-live',playing?'off':'polite');
  const video=this.slides[this.index]?.querySelector('video');
  if(video){if(playing&&this.visible&&!this.reduced.matches&&!document.hidden)video.play().catch(()=>{});else video.pause()}
  if(playing&&this.slides.length>1&&this.visible&&!this.hovered&&!this.focused&&!this.editor&&!document.hidden)this.timer=setTimeout(()=>this.go(this.index+1),this.interval);
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-language-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('language-search')) {
    customElements.define('language-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input'); this.clear = this.querySelector('[data-clear]'); this.count = this.querySelector('[data-count]'); this.region = 'All'; this.counts = {};
        this.input.addEventListener('input', () => this.update());
        this.clear.addEventListener('click', () => { this.input.value = ''; this.input.focus(); this.update(); });
        this.querySelectorAll('[data-region]').forEach((button) => button.addEventListener('click', () => { this.region = button.dataset.region; this.querySelectorAll('[data-region]').forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false')); this.update(); }));
        this.empty = this.querySelector('[data-global-empty]');
        this.onCount = (event) => { this.counts[event.detail.source] = event.detail.count; const total = Object.values(this.counts).reduce((sum, value) => sum + value, 0); this.count.textContent = `${total} ${total === 1 ? 'language' : 'languages'} found`; if (this.empty) this.empty.hidden = Object.keys(this.counts).length < 2 || total > 0; };
        document.addEventListener('viaim:language-count', this.onCount); setTimeout(() => this.update(), 0);
      }
      disconnectedCallback() { document.removeEventListener('viaim:language-count', this.onCount); }
      update() { this.clear.hidden = !this.input.value; this.counts = {}; document.dispatchEvent(new CustomEvent('viaim:language-filter', { detail: { query: this.input.value.trim().toLowerCase(), region: this.region } })); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-language-variants"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('language-results')) {
    customElements.define('language-results', class extends HTMLElement {
      connectedCallback() { this.onFilter = (event) => this.filter(event.detail); document.addEventListener('viaim:language-filter', this.onFilter); this.querySelectorAll('details').forEach((details) => { const summary = details.querySelector('summary'); const sync = () => summary.setAttribute('aria-expanded', details.open ? 'true' : 'false'); details.addEventListener('toggle', sync); sync(); }); this.filter({ query: '', region: 'All' }); }
      disconnectedCallback() { document.removeEventListener('viaim:language-filter', this.onFilter); }
      filter({ query, region }) { let count = 0; this.querySelectorAll('[data-result]').forEach((item) => { const regionMatch = region === 'All' || item.dataset.regions.split(',').map((value) => value.trim()).includes(region); const match = regionMatch && (!query || item.dataset.search.includes(query)); item.hidden = !match; if (match) count += 1; }); const empty = this.querySelector('[data-empty]'); if (empty) empty.hidden = true; document.dispatchEvent(new CustomEvent('viaim:language-count', { detail: { source: this.dataset.source, count } })); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-product-navigation"] && !Shopify.designMode) return;
  try {
    
class ProductScrollNavigation extends HTMLElement{
 connectedCallback(){
  if(!this.hasAttribute('data-scroll-enabled'))return;
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
  this.host=this.closest('.shopify-section');if(!this.host)return;
  const info=document.querySelector('#MainContent product-info');
  const target=info?.closest('.shopify-section')||document.getElementById('MainContent');
  const button=this.querySelector('[data-product-top]');
  if(target?.id&&button)button.setAttribute('href','#'+target.id);
  const update=()=>{this.frame=0;const start=target?target.getBoundingClientRect().top+window.scrollY:0;const visible=window.scrollY>Math.max(120,start+64);this.host.classList.toggle('vpd-nav-visible',visible);this.inert=!visible;this.setAttribute('aria-hidden',String(!visible))};
  const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(update)};
  window.addEventListener('scroll',schedule,{passive:true,signal});window.addEventListener('resize',schedule,{passive:true,signal});window.addEventListener('pageshow',schedule,{signal});
  button?.addEventListener('click',event=>{
   if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||!target)return;
   event.preventDefault();event.stopPropagation();
   const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height'))||0;
   window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+window.scrollY-header),behavior:'instant'});
   update();
   target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
  },{capture:true,signal});update();
 }
 disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);this.host?.classList.remove('vpd-nav-visible')}
}
if(!customElements.get('product-scroll-navigation'))customElements.define('product-scroll-navigation',ProductScrollNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-product-overview"] && !Shopify.designMode) return;
  try {
    
class ProductIntroScene extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal,copy=this.querySelector('.vpi__copy'),video=this.querySelector('video'),button=this.querySelector('[data-intro-play]'),motion=matchMedia('(prefers-reduced-motion:reduce)');let shown=false,pausedByUser=false;
 const sync=()=>{if(button){button.textContent=video.paused?button.dataset.playLabel:button.dataset.pauseLabel;button.setAttribute('aria-pressed',String(!video.paused))}};
 if(video){video.addEventListener('play',sync,{signal});video.addEventListener('pause',sync,{signal});button?.addEventListener('click',()=>{pausedByUser=!video.paused;if(video.paused)video.play().catch(()=>{});else video.pause()},{signal});sync()}
 this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){if(!shown){shown=true;if(!motion.matches)this.animation=copy.animate([{opacity:.2,transform:'scale(.94) translateY(14px)'},{opacity:1,transform:'scale(1) translateY(0)'}],{duration:800,easing:'cubic-bezier(.23,1,.32,1)'})}if(video&&!pausedByUser&&!motion.matches)video.play().catch(()=>{})}else video?.pause()})},{threshold:.15});this.observer.observe(this);motion.addEventListener('change',()=>{this.animation?.cancel();if(motion.matches)video?.pause()},{signal});
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animation?.cancel();this.querySelector('video')?.pause()}
}
if(!customElements.get('product-intro-scene'))customElements.define('product-intro-scene',ProductIntroScene);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-recording-guidance"] && !Shopify.designMode) return;
  try {
    
class RecordingCueGuide extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const toggle=this.querySelector('[data-cue-toggle]'),body=this.querySelector('.vcg__body'),label=this.querySelector('[data-cue-label]');
 const setOpen=open=>{toggle.setAttribute('aria-expanded',String(open));body.hidden=!open;label.textContent=open?label.dataset.closeLabel:label.dataset.openLabel;if(open&&!matchMedia('(prefers-reduced-motion:reduce)').matches)body.animate([{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}],{duration:250,easing:'cubic-bezier(.23,1,.32,1)'});};
 toggle.addEventListener('click',()=>setOpen(toggle.getAttribute('aria-expanded')!=='true'),{signal});
 this.querySelectorAll('[data-cue-step]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-cue-step]').forEach(x=>x.setAttribute('aria-pressed',String(x===button)));this.querySelectorAll('[data-cue-panel]').forEach(x=>x.hidden=x.dataset.cuePanel!==button.dataset.cueStep)},{signal}));
 this.addEventListener('shopify:block:select',e=>{setOpen(true);e.target.closest('[data-cue-step]')?.click()},{signal});
 this.observer=new IntersectionObserver(entries=>{if(entries.some(x=>x.isIntersecting)){this.classList.add('is-visible');this.observer.disconnect()}},{threshold:.2});this.observer.observe(this);
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
}
if(!customElements.get('recording-cue-guide'))customElements.define('recording-cue-guide',RecordingCueGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaim-story-steps"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('viaim-story-steps'))customElements.define('viaim-story-steps',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
  this.links=[...this.querySelectorAll('[data-step]')];this.chapters=[...this.querySelectorAll('[data-chapter]')];
  this.nav=this.querySelector('.vss__nav');this.indicator=this.querySelector('.vss__indicator');
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.active=0;this.lockUntil=0;
  const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
  this.links.forEach((link,i)=>link.addEventListener('click',event=>{
   event.preventDefault();this.activate(i);this.lockUntil=performance.now()+900;
   this.chapters[i].scrollIntoView({block:'start',behavior:this.reduced.matches||event.detail===0?'instant':'smooth'});
  },{signal}));
  window.addEventListener('scroll',schedule,{passive:true,signal});window.addEventListener('resize',schedule,{passive:true,signal});
  ['wheel','touchstart'].forEach(type=>window.addEventListener(type,()=>{this.lockUntil=0},{passive:true,signal}));
  this.addEventListener('shopify:block:select',event=>{
   const i=this.chapters.findIndex(c=>c.dataset.chapter===event.detail.blockId);if(i<0)return;
   this.activate(i);this.lockUntil=performance.now()+900;this.chapters[i].scrollIntoView({block:'start',behavior:'instant'});
  },{signal});
  this.resize=new ResizeObserver(schedule);this.resize.observe(this.nav);this.update();
  document.fonts?.ready.then(()=>{if(this.isConnected)this.update()});
 }
 activate(index){
  this.active=index;this.links.forEach((link,i)=>{if(i===index)link.setAttribute('aria-current','step');else link.removeAttribute('aria-current')});
  const link=this.links[index];if(link)this.indicator.style.transform=`translateY(${link.offsetTop}px) scaleY(${link.offsetHeight})`;
 }
 update(){
  if(!this.chapters.length)return;
  if(performance.now()<this.lockUntil){this.activate(this.active);return}
  const center=innerHeight*.5;let closest=0,distance=Infinity;
  this.chapters.forEach((chapter,i)=>{const r=chapter.getBoundingClientRect();const d=Math.abs(r.top+r.height/2-center);if(d<distance){closest=i;distance=d}});
  this.activate(closest);
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();
})();
